import { EventEmitter, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'gif' })
export class GifPipe implements PipeTransform {
  transform(text: string, scrollToBottom: EventEmitter<any>) {
    if (text.includes('.gif')) {
      const regex = /(?=https).*?(gif)/gm;
      const gif = text.match(regex);
      if (!gif) return text;

      const image = new Image();
      image.src = gif[0];
      image.onload = () => {
        scrollToBottom.emit();
      };

      return `<ion-img src="${gif}"  alt="gif" style="border-radius: 8px; overflow: hidden; margin-top: 10px;"></ion-img>`;
    } else {
      return text;
    }
  }
}
